import { z } from "zod";

export interface AddFontFormValues {
  fileList: File[];
  isLicenseDeclared: boolean;
}

export const addFontSchema: z.ZodType<AddFontFormValues, AddFontFormValues> =
  z.object({
    fileList: z.array(z.instanceof(File)).min(1),
    isLicenseDeclared: z.boolean().refine((isDeclared) => isDeclared),
  });
